import {
  Emision,
  emitirFactura,
  emitirDocumentoSoporte,
  emitirFacturaExoprtacion,
  emitirNotaCredito,
  emitirNotaCreditoDocumentoSoporte,
  emitirNotaDebito,
} from "./SubMenus/Emision";
import { Nomina } from "./SubMenus/Nomina";
import { Consultas, DocumentosEmitidosSoporte, DocumentosEmitidosFacturacion } from "./SubMenus/Consultas";
import { productos, adquirentes } from "./SubMenus/Maestros";
import { Configuracion, gestionResoluciones } from "./SubMenus/Configuracion";
import { eventosMercantiles } from "./SubMenus/Gastos";
import { Pqrs } from "./SubMenus/PQRS";

export const Emisor = [
  {
    isNoView: "true",
    pathname: "/Home",
    principal: "true",
  },
  {
    pathname: "/recargar_saldo",
    isNotView: "true",
  },
  gestionResoluciones,
  adquirentes,
  productos,
  emitirFactura,
  emitirFacturaExoprtacion,
  Nomina,
  eventosMercantiles,
  emitirDocumentoSoporte,
  emitirNotaCredito,
  emitirNotaDebito,
  emitirNotaCreditoDocumentoSoporte,
  DocumentosEmitidosFacturacion,
  DocumentosEmitidosSoporte,
  Configuracion,
  Emision,
  Consultas,
  Pqrs,
];
